import { fExecuteAPI } from "../../Server/Apis";
import { LoadingList_LoadingListAttributes_GETROW } from "../../Server/ApiV2";
import moment from "moment";

// import "react-confirm-alert/src/react-confirm-alert.css"; // Import css

import { vRdxUserInfo, RoLoadingLists, KernCAConfig } from "../../Redux/roStore";

import {
  fcheck_null_undefine_replace_empty,
  fAlertToast,
} from "../../Utility/Utilitys";
// LoadingList
var vheaderArrow = 0;
export const fRightClick = (e) => {
  vheaderArrow !== 1 ? (vheaderArrow = vheaderArrow + 1) : (vheaderArrow = 1);

  var headerMainTag = document.getElementById(
    "wms-salese-invoice-id"
  ).childNodes;
  for (let index = 0; index < headerMainTag.length; index++) {
    if (vheaderArrow === index) {
      headerMainTag[index].classList.add("main-wms-sales-invoice-show-sm");
    } else {
      headerMainTag[index].classList.remove("main-wms-sales-invoice-show-sm");
    }
  }
};

export const fLeftClick = (e) => {
  vheaderArrow !== 0 ? (vheaderArrow = vheaderArrow - 1) : (vheaderArrow = 0);
  var headerMainTag = document.getElementById(
    "wms-salese-invoice-id"
  ).childNodes;
  for (let index = 0; index < headerMainTag.length; index++) {
    if (vheaderArrow === index) {
      headerMainTag[index].classList.add("main-wms-sales-invoice-show-sm");
    } else {
      headerMainTag[index].classList.remove("main-wms-sales-invoice-show-sm");
    }
  }
};

//detailgridend
//audit
export const GridDataAuditColumns = [
  { field: "id", headerName: "ID", width: 70, hide: true },

  {
    field: "User",
    headerName: "User Name",
    width: 130,
    headerClassName: "grid-header-row",
  },
  {
    field: "Date",
    headerName: "Date",
    width: 100,
    headerClassName: "grid-header-row",
  },
  {
    field: "Time",
    headerName: "Time",
    width: 100,
    headerClassName: "grid-header-row",
  },
  {
    field: "IP Address",
    headerName: "IP Address",
    width: 130,
    headerClassName: "grid-header-row",
  },
  {
    field: "Old Value",
    headerName: "Old Value",
    width: 100,
    headerClassName: "grid-header-row",
  },
  {
    field: "New Value",
    headerName: "New Value",
    width: 150,
    headerClassName: "grid-header-row",
  },
  {
    field: "ItmCd",
    headerName: "Item Code",
    width: 150,
    headerClassName: "grid-header-row",
  },
  {
    field: "ItmName",
    headerName: "Item Name",
    width: 250,
    headerClassName: "grid-header-row",
  },
];
//audit end
//search start
export const sStatusArr = ["ENTER", "ALL", "POST", "DELETE", "DRAFT"];
export const GridDataColumnsSearch = [
  { field: "id", headerName: "ID", width: 70, hide: true },
  { field: "VocName", headerName: "Doc.Name", width: 250 },
  { field: "A_VocNo", headerName: "Doc.No", width: 150 },
  {
    field: "A_VocDt",
    headerName: "Date",
    width: 200,
    valueFormatter: ({ value }) => moment(value).format("DD/MM/YYYY"),
  },
  { field: "B_RefDocNo", headerName: "Ref.No", width: 100 },
  { field: "PartyName", headerName: "Party", width: 300 },
  { field: "LocName", headerName: "Location", width: 130 },
  { field: "Cluster", headerName: "Cluster", width: 90 },
  { field: "Transaction", headerName: "Transaction", width: 150 },
  { field: "Truck", headerName: "Truck", width: 90 },
  { field: "LocadingBay", headerName: "LocadingBay", width: 90, hide: true },
  { field: "Status", headerName: "Status", width: 90, hide: true },
  { field: "Loaded", headerName: "Loaded", width: 90, hide: true },
  { field: "Received", headerName: "Received", width: 90, hide: true },
];
//search end

//head Start
//party start

//customer
export const xGC_Toggle_Head_Customer_GridColumns_def = [
  { field: "id", headerName: "ID", width: 70, hide: true },
  { field: "AcCd", headerName: "Code", width: 90 },
  { field: "Name1", headerName: "Name1", width: 450 },
  { field: "Name2", headerName: "Name2", width: 450 },
  // { field: "Name1", headerName: "Name1", width: 220 },
];
export const xGC_Toggle_Head_Customer_DropDown_Arr = ["Any", "Code", "Name"];

const Get_ToggleDropDown_Load = async (
  xData,
  xType,
  xAcTyp,
  xExact,
  dispatch
) => {
  const { HeadObject } = RoLoadingLists();
  let vLoaded_Cost_FreightObj = {
    Data: xData,
    Type: xType,
    Loc: HeadObject.A_Loc,
    AcTyp: xAcTyp,
    Exact: xExact,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(vLoaded_Cost_FreightObj);
  const vLandedCostDropdownSearch = await fExecuteAPI(
    "AccountTransSearch_GETROW",
    FinalObj
  );
  if (vLandedCostDropdownSearch?.Type?.toUpperCase() === "SUCCESS") {
    let GridID = [];
    if (vLandedCostDropdownSearch.ResultSet.length > 0) {
      let GridID = vLandedCostDropdownSearch.ResultSet?.map((obj, i) => ({
        ...obj,
        id: i + 1,
      }));
      return GridID;
    } else {
      return GridID;
    }
  } else {
    fAlertToast("FAILED", "Error in loading LandedCost Api");
    return [];
  }
};
//party end
export const ErrorMsg = {
  A_VocTyp: "",
  A_VocNo: "",
  A_PostDt: "",
  UnloadingBay: "",
  A_Party: "",
  A_PartyName: "",
  A_Loc: "",
  A_Type: "",
  A_DocStat: "",
  xErrorMsg: "",
  Cluster: "",
  Transaction: "",
  Truck: "",
  Driver: "",
  DriverName: "",
  TruckCBM: "",
  ItemCBM: 0,
  TotalWeight: 0,
};
export const fValidationHead_Client = (
  vRdxHead,
  vRdxLoadingListUserCheckbox,
  setErrorMsg
) => {
  let iRes = true;

  if (
    vRdxHead.A_VocTyp === "" ||
    vRdxHead.A_VocTyp === null ||
    vRdxHead.A_VocTyp === undefined
  ) {
    setErrorMsg((obj) => ({
      ...obj,
      A_VocTyp: "VocTyp should not be empty",
    }));
    fAlertToast("INFO", "VocTyp should not be empty");
    iRes = false;
  }

  if (
    vRdxHead.A_VocNo === "" ||
    vRdxHead.A_VocNo === null ||
    vRdxHead.A_VocNo === undefined
  ) {
    setErrorMsg((obj) => ({ ...obj, A_VocNo: "VocNo should not be empty" }));
    fAlertToast("INFO", "VocNo should not be empty");
    iRes = false;
  }

  if (
    vRdxHead.A_PostDt === "" ||
    vRdxHead.A_PostDt === null ||
    vRdxHead.A_PostDt === undefined
  ) {
    setErrorMsg((obj) => ({
      ...obj,
      A_PostDt: "PostDt should not be empty",
    }));
    fAlertToast("INFO", "PostDt should not be empty");
    iRes = false;
  }

  if (
    vRdxHead.UnloadingBay === "" ||
    vRdxHead.UnloadingBay === null ||
    vRdxHead.UnloadingBay === undefined
  ) {
    setErrorMsg((obj) => ({
      ...obj,
      UnloadingBay: "Unloading should not be Empty",
    }));
    fAlertToast("INFO", "Unloading should not be Empty");
    iRes = false;
  }

  if (
    vRdxHead.A_Type === "" ||
    vRdxHead.A_Type === null ||
    vRdxHead.A_Type === undefined
  ) {
    setErrorMsg((obj) => ({
      ...obj,
      A_Type: "GRN Type should not be empty",
    }));
    fAlertToast("INFO", "GRN Type should not be empty");
    iRes = false;
  }

  if (
    vRdxHead.A_Loc === "" ||
    vRdxHead.A_Loc === null ||
    vRdxHead.A_Loc === undefined
  ) {
    setErrorMsg((obj) => ({ ...obj, A_Loc: "Location should not be Empty" }));
    fAlertToast("INFO", "Location should not be Empty");
    iRes = false;
  }

  if (
    vRdxHead.A_Party === "" ||
    vRdxHead.A_Party === null ||
    vRdxHead.A_Party === undefined
  ) {
    setErrorMsg((obj) => ({
      ...obj,
      A_PartyName: "Party should not be empty",
    }));
    fAlertToast("INFO", "Party should not be empty");
    iRes = false;
  }

  if (
    vRdxHead.A_PartyName === "" ||
    vRdxHead.A_PartyName === null ||
    vRdxHead.A_PartyName === undefined
  ) {
    setErrorMsg((obj) => ({
      ...obj,
      A_PartyName: "Party Name should not be empty",
    }));
    fAlertToast("INFO", "Party Name should not be empty");
    iRes = false;
  }

  if (
    vRdxHead.Cluster === "" ||
    vRdxHead.Cluster === null ||
    vRdxHead.Cluster === undefined
  ) {
    setErrorMsg((obj) => ({ ...obj, Cluster: "Cluster should not be Empty" }));
    fAlertToast("INFO", "Cluster should not be Empty");
    iRes = false;
  }

  if (
    vRdxHead.Transaction === "" ||
    vRdxHead.Transaction === null ||
    vRdxHead.Transaction === undefined
  ) {
    setErrorMsg((obj) => ({
      ...obj,
      Transaction: "Transaction should not be Empty",
    }));
    fAlertToast("INFO", "Transaction should not be Empty");
    iRes = false;
  }

  if (
    vRdxHead.Truck === "" ||
    vRdxHead.Truck === null ||
    vRdxHead.Truck === undefined
  ) {
    setErrorMsg((obj) => ({ ...obj, Truck: "Truck should not be Empty" }));
    fAlertToast("INFO", "Truck should not be Empty");
    iRes = false;
  }

  if (
    vRdxHead.Driver === "" ||
    vRdxHead.DriverName === "" ||
    vRdxHead.Driver === null ||
    vRdxHead.Driver === undefined ||
    vRdxHead.DriverName === null ||
    vRdxHead.DriverName === undefined
  ) {
    setErrorMsg((obj) => ({
      ...obj,
      DriverName: "DriverName should not be Empty",
    }));
    fAlertToast("INFO", "DriverName should not be Empty");
    iRes = false;
  }

  if (
    vRdxHead.TruckCBM === "" ||
    vRdxHead.TruckCBM === null ||
    vRdxHead.TruckCBM === undefined
  ) {
    setErrorMsg((obj) => ({
      ...obj,
      TruckCBM: "TruckCBM should not be Empty",
    }));
    fAlertToast("INFO", "TruckCBM should not be Empty");
    iRes = false;
  }

  if (
    vRdxHead.ItemCBM === "" ||
    vRdxHead.ItemCBM === null ||
    vRdxHead.ItemCBM === undefined
  ) {
    setErrorMsg((obj) => ({ ...obj, ItemCBM: "ItemCBM should not be Empty" }));
    fAlertToast("INFO", "ItemCBM should not be Empty");
    iRes = false;
  }

  if (
    vRdxHead.TotalWeight === "" ||
    vRdxHead.TotalWeight === null ||
    vRdxHead.TotalWeight === undefined
  ) {
    setErrorMsg((obj) => ({
      ...obj,
      TotalWeight: "TotalWeight should not be Empty",
    }));
    fAlertToast("INFO", "TotalWeight should not be Empty");
    iRes = false;
  }

  return iRes;
};

//head end

const GetLoadingListCheckbox = async (xVocTyp, xVocNo, dispatch) => {
  let checkboxObj = {
    VocTyp: !!xVocTyp ? xVocTyp : "",
    VocNo: !!xVocNo ? xVocNo : 0,
  };
  const vLoadingListCheckbox = await fExecuteAPI(
    "LoadingList_loadinglistcheckbox_GETROW",
    checkboxObj
  );
  if (vLoadingListCheckbox?.Type?.toUpperCase() === "SUCCESS") {
    return vLoadingListCheckbox?.ResultSet;
  } else {
    fAlertToast(
      "FAILED", vLoadingListCheckbox?.response?.data?.message
        ||"Error in LoadingListCheckbox"
    );
    return [];
  }
};
export const AllPartyFlag = () => {
  const { DBKernObj } = KernCAConfig(); 
  const iShowField = DBKernObj.WMS_LOADING_LIST_ALL_PARTY?.Val === 'Y';
  if (iShowField) {
    return true;
  } else {
    return false;
  }
};


//API GETSIDETAILS_GETROW
const GetSIDetail = async (xB_VocNo, xVocTyp) => {
  const { HeadObject } = RoLoadingLists();
  let iSIDetailObj = {
    VocTyp: !!xVocTyp ? xVocTyp : "",
    VocNo: !!xB_VocNo ? xB_VocNo : 0,
    Cluster: HeadObject.Cluster,
    Party: HeadObject.A_Party,
    Loc: HeadObject.A_Loc,
    Trans: HeadObject.Transaction,
    LDBAY: HeadObject.UnloadingBay,
    // VocTyp: HeadObject.A_VocTyp,
    // VocNo: HeadObject.A_VocNo,
    // VocTyp: "LD001",
    // VocNo: "LDSDC00002",
    // Cluster: "",
    // Party: "D0001",
    // Loc: "64",
    // Trans: "VOUCH70",
    // LDBAY: "101114",
  };
  let FinalObj = fcheck_null_undefine_replace_empty(iSIDetailObj);

  const iSIDetailResult = await fExecuteAPI(
    "LoadingList_GridLoad_GETROW",
    FinalObj
  );
  if (iSIDetailResult?.Type?.toUpperCase() === "SUCCESS") {
    if (iSIDetailResult.ResultSet.length > 0) {
      return iSIDetailResult.ResultSet;
    } else {
      return [];
    }
  }
};

export const GetAttributes = async (
  setUser_Doc_Arr,
  setObjectRights,
  setDocLoading,
  setClusterArr,
  setLocationArr,
  setTransactionArr,
  setTruckArr,
  setUnloadingBayArr
) => {
  const vRdxUserInfoObj = vRdxUserInfo();
  var vDCRequestObj = {
    userCode: vRdxUserInfoObj.UserID,
    userGroupCode: vRdxUserInfoObj.UserGroupCode,
  };
  const iAttributes = await LoadingList_LoadingListAttributes_GETROW(
    vDCRequestObj
  );
  if (iAttributes?.status === 200) {
    setUser_Doc_Arr(iAttributes?.data?.ResultSet?.UserDoc);
    setObjectRights(iAttributes?.data?.ResultSet?.Rights);
    setDocLoading(iAttributes?.data?.ResultSet?.DocLoading);
    setClusterArr(iAttributes?.data?.ResultSet?.Cluster);
    // setLocationArr(iAttributes?.data?.ResultSet?.Loaction);// by sir
    setTransactionArr(iAttributes?.data?.ResultSet?.Transaction);
    setTruckArr(iAttributes?.data?.ResultSet?.Truck);
    setUnloadingBayArr(iAttributes?.data?.ResultSet?.Loading_Pay);
    return iAttributes?.data?.ResultSet;
  } else {
    return [];
  }
};
//API end

// useEffect(() => {
//   GetGitterColumns(
//     setGridcolumnsDCREQT,
//     "LOACDINGLIST_LDST",
//     Gridcolumns
//   );
// }, []);

export {
  // rows,
  // columns,
  //customer
  Get_ToggleDropDown_Load,
  //customer end
  GetLoadingListCheckbox,
  GetSIDetail,
  //API end
};
